// Angular import
import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';

// project import
import { SpinnerComponent } from './theme/shared/components/spinner/spinner.component';
import { ImageViewerComponent } from './theme/shared/components/image-viewer/image-viewer.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SpinnerComponent, ImageViewerComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private router = inject(Router);

  // public props
  title = 'VeloRide Admin';

  // Life cycle events
  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        return;
      }
      if (evt instanceof NavigationError) {
        const msg: string = evt.error?.message ?? '';
        if (
          msg.includes('Failed to fetch dynamically imported module') ||
          /Loading chunk [\d]+ failed/.test(msg)
        ) {
          window.location.assign(evt.url);
        }
      }
    });
  }
}
